import React from 'react'
import PropTypes from 'prop-types'
import styles from  './ContentWrapper.module.scss'

const ContentWrapper = props => {
    return (
        <div className={styles.contentWrapper}>
            {props.children}
        </ div>
    )
}

ContentWrapper.propTypes = {
    children: PropTypes.any,
}

export default ContentWrapper
